function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Tabs/Warmte/Royal-Blue",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(2.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "W",
  fill: "#425CD4",
  fillRule: "nonzero",
  points: "3.10275 12.712 5.11875 12.69625 7.56 4.41175 9.8595 12.69625 11.89125 12.69625 15.13575 1.75 13.21425 1.75 10.9305 10.61725 8.64675 1.75 6.63075 1.75 4.17375 10.6645 1.90575 1.75 -2.66453526e-13 1.75"
}), /*#__PURE__*/React.createElement("g", {
  id: "Temperature/Warmte/Wit-Copy",
  transform: "translate(16.625000, -0.000000)",
  stroke: "#425CD4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.8125,8.99383333 L4.8125,2.1875 C4.8125,1.22100169 4.02899831,0.4375 3.0625,0.4375 C2.09600169,0.4375 1.3125,1.22100169 1.3125,2.1875 L1.3125,8.99383333 C0.418137862,9.79941207 0.187461684,11.110614 0.753186974,12.1730619 C1.31891226,13.2355098 2.53558491,13.7760369 3.70321357,13.4836604 C4.87084222,13.1912838 5.68921689,12.1411768 5.6875027,10.9375 C5.68591087,10.1945727 5.36763103,9.48756709 4.8125,8.99383333 L4.8125,8.99383333 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 3.0625,
  y1: 2.1875,
  x2: 3.0625,
  y2: 10.0625,
  id: "Path"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 3.0625,
  cy: 10.9375,
  r: 1
}), /*#__PURE__*/React.createElement("line", {
  x1: 7,
  y1: 7.35,
  x2: 8.4,
  y2: 7.35,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 7,
  y1: 5.25,
  x2: 8.4,
  y2: 5.25,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 7,
  y1: 3.15,
  x2: 8.4,
  y2: 3.15,
  id: "Path"
}))));
function SvgHeatUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "20px",
    viewBox: "0 0 30 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Tabs/Warmte/Royal Blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatUnselected);
export default __webpack_public_path__ + "static/media/Heat_unselected.2f902a84fb4359f2c87fafab5ca0a281.svg";
export { ForwardRef as ReactComponent };